module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_1-70c27e1645e31730265a4a66e4604a5e.jpg";